// extracted by mini-css-extract-plugin
export default {"brandPromo":"EG-z","carousel":"FG-z"};